import {
  collection,
  getDocs,
  query,
  limit,
  startAfter,
  QueryDocumentSnapshot,
  DocumentData,
  orderBy,
  getCountFromServer,
  where,
} from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import UserDoc from '../../models/UserDoc';
import { UserRole } from '@leedpulse-monorepo/enums';

async function getUsers(
  offset: number,
  roleConstraint: UserRole | undefined | null,
  lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData>
): Promise<{
  users: UserDoc[];
  lastVisible: QueryDocumentSnapshot<DocumentData, DocumentData>;
  totalAllCount: number;
  totalCollectionCount: number;
}> {
  try {
    const db = firestore;
    const usersCollection = collection(db, FirestoreCollections.users);
    const results = lastVisible
      ? await getDocs(
          query(
            usersCollection,
            ...(roleConstraint ? [where('role', '==', roleConstraint)] : []),
            orderBy('created', 'desc'),
            startAfter(lastVisible),
            limit(offset)
          )
        )
      : await getDocs(
          query(
            usersCollection,
            ...(roleConstraint ? [where('role', '==', roleConstraint)] : []),
            orderBy('created', 'desc'),
            limit(offset)
          )
        );

    const users: UserDoc[] = [];

    results.docs.forEach((doc) => {
      users.push(UserDoc.fromFirestore(doc));
    });

    const usersSnapshot = await getCountFromServer(
      query(usersCollection, ...(roleConstraint ? [where('role', '==', roleConstraint)] : []))
    );

    const usersSnapshotAll = await getCountFromServer(
      query(usersCollection)
    );

    return {
      users,
      lastVisible: results.docs[results.docs.length - 1],
      totalAllCount: usersSnapshotAll.data().count ?? 0,
      totalCollectionCount: usersSnapshot.data().count ?? 0,
    };
  } catch (e) {
    console.error('error: ', e);
    throw new GetUsersFailure();
  }
}

export class GetUsersFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUsers;
